import { FrameUnit, TimelineGap } from './type'

export function resolveGapFrames(gap: TimelineGap): TimelineGap['frames'] {
  return gap.frames - 1
}

export function getGapOffsetFrames(
  f: FrameUnit,
  gaps: TimelineGap[],
): FrameUnit {
  const beforeGaps = gaps.filter((g) => f > g.in)
  const beforeGapsFrames = beforeGaps.reduce(
    (frames, g) => (frames += resolveGapFrames(g)),
    0,
  )

  return beforeGapsFrames
}
